import { Box } from "@chakra-ui/react";
import type { ContributingEntityCommitmentDto } from "../../../../../autogen/bff-api";
import { StepNavigation } from "../../../../../common/StepNavigation";
import type { ContributionAudience } from "../ContributionWizard";
import { ContributingCommitmentCard } from "../ContributingCommitmentCard";

interface Props {
  leadSupplierName: string;
  commitment: ContributingEntityCommitmentDto | null | undefined;
  onChange: (next: ContributingEntityCommitmentDto) => void;
  readOnly: boolean;
  audience: ContributionAudience;
  previousStep?: () => void;
  nextStep?: () => void;
  nextStepLabel?: string;
}

export const ContributionCommitmentStep = ({
  leadSupplierName,
  commitment,
  onChange,
  readOnly,
  audience,
  previousStep,
  nextStep,
  nextStepLabel,
}: Props) => (
  <Box pb="8" pt="6">
    <ContributingCommitmentCard
      leadSupplierName={leadSupplierName}
      commitment={commitment}
      onChange={onChange}
      readOnly={readOnly}
      audience={audience}
    />
    <StepNavigation onPrevious={previousStep} onNext={nextStep} nextLabel={nextStepLabel} />
  </Box>
);
